var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.onerror = (error) => reject(error);
    });
};
export const base64ToFile = (base64_1, ...args_1) => __awaiter(void 0, [base64_1, ...args_1], void 0, function* (base64, fileName = '', type = 'image/jpeg') {
    const data = yield fetch(base64);
    const blobData = yield data.blob();
    return new File([blobData], fileName, { type });
});
export const downloadBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
};
const SIZE_UNITS = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
export const formatBytes = (bytes, options) => {
    if (bytes === 0)
        return '0 Bytes';
    const { decimals = 2, unit = 'binary', rounding = true } = options !== null && options !== void 0 ? options : {};
    const isBinary = unit === 'binary';
    const base = isBinary ? 1024 : 1000;
    const sign = bytes < 0 ? -1 : 1;
    const abs = Math.abs(bytes);
    let metric = isBinary ? Math.floor(Math.log2(abs) / 10) : Math.floor(Math.log10(abs) / 3);
    if (metric < 0)
        metric = 0;
    if (metric >= SIZE_UNITS.length)
        metric = SIZE_UNITS.length - 1;
    const divisor = Math.pow(base, metric);
    let value = (abs / divisor) * sign;
    const factor = Math.pow(10, decimals);
    if (rounding) {
        value = Math.round(value * factor) / factor;
    }
    else {
        value = Math.trunc(value * factor) / factor;
    }
    const displayed = Number(value.toFixed(decimals));
    return `${displayed} ${SIZE_UNITS[metric]}`;
};
export const getFileImageDimensions = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    yield img.decode();
    const width = img.width;
    const height = img.height;
    return {
        width,
        height,
    };
});
